import * as types from "../actionTypes";

export const setSubscriptionCommissionByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SUBSCRIPTION_COMMISSION_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setSubscriptionCommissionByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SUBSCRIPTION_COMMISSION_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceSubscriptionCommissionByYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_SUBSCRIPTION_COMMISSION_YEARS,
      key,
      payload,
    });
  };
};

export const resetSubscriptionCommissionReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_SUBSCRIPTION_COMMISSION_REDUCER,
    });
  };
};
